import { render, staticRenderFns } from "./WalletAdmin.vue?vue&type=template&id=52455596&scoped=true"
import script from "./WalletAdmin.vue?vue&type=script&lang=js"
export * from "./WalletAdmin.vue?vue&type=script&lang=js"
import style0 from "./WalletAdmin.vue?vue&type=style&index=0&id=52455596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52455596",
  null
  
)

export default component.exports